module.exports = __webpack_public_path__ + "img/mech-psych.6a384cf1.jpg";